//for breadcrumbs in collection pages
document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 1025) {
        const breadcrumb = document.querySelector('#shopify-section-template--28749518340438__breadcrumb_ztwnCj nav.breadcrumbs');
        const to = document.querySelector('#shopify-section-template--28749518340438__section_GXC9tn .custom-section-content');
        breadcrumb && to && to.prepend(breadcrumb);
    }

    const nuggets = document.querySelector('.shopify-section .color-scheme-2:has(.reviews-io-nuggets-widget)');
    const nuggetsTo = document.querySelector('.product-information--media-left .product-details > .group-block > .group-block-content ');
    nuggets && nuggetsTo && nuggetsTo.append(nuggets);

  //  For color <=> farbe
    function updateLegendText() {
      document.querySelectorAll("legend.form__label").forEach(legend => {
        legend.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("Color:")) {
            node.textContent = node.textContent.replace("Color:", "Farbe:");
          }
        });
      });
    }
    
    updateLegendText();

    let currentUrl = location.href;
    new MutationObserver(() => {
      if (location.href !== currentUrl) {
        currentUrl = location.href;
        if (currentUrl.includes("variant=")) {
          updateLegendText();
        }
      }
    }).observe(document, { subtree: true, childList: true });


    //For static video thumbanail
    const gallery = document.querySelector('.template-product media-gallery .swiper-controls__thumbnails');

    if (gallery) {
      // Find the original button inside it
      const originalButton = gallery.querySelector(
        'button.swiper-slide.button:has(.swiper-controls__thumbnail-badge)'
      );
      const firstButton = gallery.querySelector('button.swiper-slide.button');

      if (originalButton && firstButton) {
        // Find the destination container
        const target = document.querySelector('#static_product_video');

        if (target) {
          function syncSize() {
            const rect = firstButton.getBoundingClientRect();
            const styles = window.getComputedStyle(firstButton);
            const marginRight = parseFloat(styles.marginRight) || 0;

            target.style.width = `${rect.width + 0}px`;
            target.style.height = `${rect.height}px`;
          }

          syncSize();
          window.addEventListener('resize', syncSize);

          // Clone the button (deep clone)
          const clonedButton = originalButton.cloneNode(true);

          // When cloned button is clicked, trigger original button click
          clonedButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            originalButton.click();
          });

          // Append it inside #static_prosuct_video
          target.appendChild(clonedButton);

          originalButton.style.maxWidth = '0';
          originalButton.style.marginRight = '0';
          originalButton.style.visibility = 'hidden';
        }
      }
    }

  // hide video icon on hove hover - product detail page
  const info_icons = document.querySelectorAll(".product-media__info-icon");
  const info_dialog = document.querySelector(".video-dialog.absolute");

  if (info_icons) {
    info_icons.forEach(icon => {
      icon.addEventListener("pointerenter", () => info_dialog.style.zIndex = '0');
      icon.addEventListener("pointerleave", () => info_dialog.style.zIndex = '1');
    });
  }

   // Cart drawer: Höhe des Scrollbereichs nach jedem Re-Render / DN-Update neu setzen
  (function () {
    var observedFooter = null, ro = null, raf = 0;
    function applyCartHeight() {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      var footer = drawer.querySelector('.drawer__footer');
      var cart = drawer.querySelector('cart-drawer-items .section--main-cart');
      if (footer && cart) cart.style.setProperty('--cart-drawer-header-height', (footer.offsetHeight + 124) + 'px');
    }
    function bindFooter() {
      var drawer = document.getElementById('CartDrawer');
      var footer = drawer && drawer.querySelector('.drawer__footer');
      applyCartHeight();
      if (footer === observedFooter) return;
      if (ro) ro.disconnect();
      observedFooter = footer;
      if (footer && 'ResizeObserver' in window) { ro = new ResizeObserver(applyCartHeight); ro.observe(footer); }
    }
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; bindFooter(); });
    }
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    bindFooter();
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  })();

});


// adding ratio to forms in iframe
 const iframe = document.querySelector("iframe.forms");
if (iframe) {
  const w = iframe.getAttribute("width");
  const h = iframe.getAttribute("height");
  iframe.style.setProperty("--ratio", w + " / " + h);
}


// product title on top on mobile
window.innerWidth <= 768 && document.querySelector(".product-information__grid .product-information__media")?.before(document.querySelector("#product_heading_info"));


// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
//for Filter toggle in collection pages
const wrapper = document.querySelector('.collection-wrapper');
const facets = document.querySelector('.facets-block-wrapper');
const filterBtn = document.querySelector('a.button-secondary--AV3p2aDg1U1RpMTJlb__button_xEbgGk');

if (wrapper && facets && filterBtn) {
  const original = getComputedStyle(wrapper).getPropertyValue('--facets-vertical-col-width').trim();

  let toggled = false;
  filterBtn.addEventListener('click', e => {
    e.preventDefault();
    const num = parseFloat(original);
    const unit = original.replace(num, '');

    wrapper.style.setProperty(
      '--facets-vertical-col-width', toggled ? original : `${num - 1}${unit}`
    );
    facets.style.display = toggled ? '' : 'none';
    toggled = !toggled;
  });
}

// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
//for adding ctas in-between the product cards
const PrdGrid = document.querySelector('#ProductGridContainer ul.product-grid');

if (PrdGrid) {
  const children = PrdGrid.querySelectorAll('.product-grid__item');
  const content1 = document.querySelector('#prd_cat1');
  const content2 = document.querySelector('#prd_cat2');

  function insertAfterChild(index, content) {
    if (!content) return;

    const newChild = document.createElement('li');
    newChild.classList.add('product-grid__item');
    newChild.appendChild(content);

    // If index exists insert after it, otherwise append to end
    if (children[index]) {
      PrdGrid.insertBefore(newChild, children[index].nextSibling);
    } else {
      PrdGrid.appendChild(newChild);
    }
  }

  if (children.length < 7) {
    insertAfterChild(children.length - 1, content1);
    insertAfterChild(children.length, content2);
  } else {
    insertAfterChild(4, content1);
    insertAfterChild(7, content2);
  }
}


// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
// remove the numbers inside the product image descriptions.


const language = document.querySelector('.section-footer .menu.menu--accordion .menu__details');

if (language) {
  if (window.innerWidth > 749) {
    language.removeAttribute("open");
    language.addEventListener("click", function (e) {
      // e.preventDefault(); 

      if (language.hasAttribute("open")) {
        language.removeAttribute("open");
      } else {
        language.setAttribute("open", "");
      }
    });
  }
  const links = document.querySelectorAll(".section-footer .menu.menu--accordion a.link" );
  links.forEach((link) => {
    link.setAttribute("target", "_blank");
  });
}

// Discount Ninja: re-render pricing 2s after the cart drawer opens
// (header icon click or add-to-cart, both call CartDrawer.open()).
customElements.whenDefined('cart-drawer').then(function () {
  var proto = customElements.get('cart-drawer').prototype;
  var originalOpen = proto.open;
  var dnTimer = null;

  proto.open = function () {
    var result = originalOpen.apply(this, arguments);
    window.clearTimeout(dnTimer);
    dnTimer = window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('la:dn:app:enable'));
      console.log('[DN] la:dn:app:enable dispatched (2s after cart drawer opened)');
    }, 2000);
    return result;
  };
});